import { useState, useEffect } from 'react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Repli uniquement si les paramètres sont indisponibles (jamais la source de vérité).
const DEFAULTS = {
  nom_entreprise: 'Show Événement',
  raison_sociale: 'Market et Développement',
  adresse_encaissement: '54 rue du Ruby, 46100 Figeac',
  siret: '929 651 289 00019',
};

// Cache module-level : une seule requête /api/parametres par session.
let _cache = null;

/**
 * Identité entreprise (raison sociale, adresse d'encaissement, SIRET) lue depuis
 * les paramètres serveur — corrige ANO-ECC-08 (adresse jamais codée en dur).
 */
export function useCompanyInfo() {
  const [info, setInfo] = useState(_cache || DEFAULTS);

  useEffect(() => {
    if (_cache) { setInfo(_cache); return; }
    let cancelled = false;
    fetch(`${BACKEND}/api/parametres`)
      .then((r) => r.json())
      .then((d) => {
        const merged = {
          nom_entreprise: d.nom_entreprise || DEFAULTS.nom_entreprise,
          raison_sociale: d.raison_sociale || DEFAULTS.raison_sociale,
          adresse_encaissement: d.adresse_encaissement || DEFAULTS.adresse_encaissement,
          siret: d.siret || DEFAULTS.siret,
        };
        _cache = merged;
        if (!cancelled) setInfo(merged);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return info;
}
